import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useBookingChannels } from '../../../utilities/hooks/useBookingChannels';
import ChannelIcon from './ChannelIcon';

const KNOWN_CHANNEL_IDS = new Set([1, 2, 3, 4]);

const MultipeCustomChannelCheckbox = ({
	label,
	checbboxObj,
	itemKey,
	onFilterChannelSelected,
	setEnableScheduling,
	filterCount,
	name = null,
	type
}) => {
	const getSize = () => {
		if (!type) {
			return '16px';
		} else {
			if (type === 1) {
				return '16px';
			} else if (type === 2) {
				return '24px';
			}
		}
	};

	const bookingChannels = useBookingChannels();
	const [checkboxChecked, SetCheckboxChecked] = useState(false);

	useEffect(() => {
		SetCheckboxChecked(checbboxObj[itemKey]);
	}, []);

	const setCheckboxCheckedChoose = (selectedItemKey) => {
		let channelIds =
			JSON.parse(localStorage.getItem('bookings_filter_channel')) || [];
		SetCheckboxChecked(!checbboxObj[selectedItemKey]);
		checbboxObj[selectedItemKey] = !checbboxObj[selectedItemKey];
		Object.keys(bookingChannels).map((bookingChannel) => {
			if (bookingChannel === selectedItemKey) {
				if (checbboxObj[bookingChannel] === true) {
					if (!channelIds.includes(bookingChannel)) {
						channelIds.push(bookingChannel);
					}
				} else {
					if (channelIds.includes(bookingChannel)) {
						for (var i = 0; i < channelIds.length; i++) {
							if (channelIds[i] === bookingChannel) {
								channelIds.splice(i, 1);
							}
						}
					}
				}
			}
		});

		if (channelIds.length > 0) {
			localStorage.setItem('bookings_filter_channel', JSON.stringify(channelIds));
			setEnableScheduling(true);
		} else {
			localStorage.removeItem('bookings_filter_channel');
			if (filterCount - 1 <= 0) {
				setEnableScheduling(false);
			}
		}

		onFilterChannelSelected(channelIds);
	};

	return (
		<div
			onClick={() => setCheckboxCheckedChoose(itemKey)}
			className="form-check-container"
			style={{ marginLeft: '0' }}
			data-testid={name ? name : 'custom-checkbox'}
		>
			<div
				style={{ width: getSize(), height: getSize() }}
				className={
					'custom-checkbox ' +
					(checkboxChecked
						? type === 1 || !type
							? 'custom-checkbox-checked'
							: 'custom-checkbox-checked-medium'
						: 'custom-checkbox')
				}
			/>
			{KNOWN_CHANNEL_IDS.has(Number(itemKey)) ? (
				<ChannelIcon
					channelId={itemKey}
					style={{ marginLeft: '10px' }}
				/>
			) : null}
			<label
				style={{ marginBottom: 0, marginLeft: KNOWN_CHANNEL_IDS.has(Number(itemKey)) ? '6px' : '10px', fontWeight: 400 }}
				className="checkbox-label"
			>
				{label}
			</label>
			{name ? (
				<input
					name={name}
					type="checkbox"
					style={{ display: 'none' }}
					checked={checkboxChecked}
					readOnly={true}
					data-testid={name}
				/>
			) : null}
		</div>
	);
};

MultipeCustomChannelCheckbox.propTypes = {
	label: PropTypes.string,
	name: PropTypes.string,
	onChange: PropTypes.func,
	type: PropTypes.number,
	itemKey: PropTypes.string,
	checbboxObj: PropTypes.array,
	onFilterChannelSelected: PropTypes.func,
	setEnableScheduling: PropTypes.func,
	filterCount: PropTypes.number
};

export default MultipeCustomChannelCheckbox;
